import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class Evoryn {
  baseUrl = environment.baseURL;

  constructor(private http: HttpClient) { }

  partnerlogin(data: any) {
    return this.http.post(this.baseUrl + 'Auth/PartnerLogin', data);
  }

  partnerverifyotp(data: any) {
    return this.http.post(this.baseUrl + 'Auth/PartnerVerifyOTP', data);
  }

  fetchordercommission(data: any) {
    return this.http.post(this.baseUrl + 'Partner/FetchOrderCommission', data);
  }

  fetchbankdetails(UserID: number) {
    return this.http.get(this.baseUrl + `Partner/FetchBankDetails?UserID=${UserID}`);
  }

  addbank(data: any) {
    return this.http.post(this.baseUrl + 'Bank/AddBank', data);
  }

  fetchproduct() {
    return this.http.get(this.baseUrl + 'Partner/FetchProduct');
  }

  addwithdrawrequest(data: any) {
    return this.http.post(this.baseUrl + 'Partner/AddWithdrawRequest', data);
  }

  getallstate(CountryID: number) {
    return this.http.get(this.baseUrl + `Location/GetAllStateFrom?CountryID=${CountryID}`);
  }

  getallcountry() {
    return this.http.get(this.baseUrl + 'Location/GetAllCountry');
  }

  getallcity(StateID: number) {
    return this.http.get(this.baseUrl + `Location/GetAllCityFrom?StateID=${StateID}`);
  }

  getallpincode(CityID: number) {
    return this.http.get(this.baseUrl + `Location/GetAllPincodeFrom?CityID=${CityID}`);
  }

  getallarea(PincodeID: number) {
    return this.http.get(this.baseUrl + `Location/GetAllAreaFrom?PincodeID=${PincodeID}`);
  }

  partnersignup(data: any) {
    return this.http.post(this.baseUrl + 'Auth/AddPartnerProfile', data);
  }
}
